<title>{{ iagPortalUserManagementPage.htmlTitle }}</title>
<div class="container">
  <app-section [sections]="iagPortalUserManagementPage.sectionsUserManagement" [isIAGPortalDocumentationPage]="true"> </app-section>
  <app-iag-portal-accordian-section class="accordianImageAuto" [accordianSections]="iagPortalUserManagement.sectionImageAccordian"></app-iag-portal-accordian-section>
  <app-section [sections]="iagPortalUserManagementPage.sectionsUserManagementAddingAdmin" [isIAGPortalDocumentationPage]="true"> </app-section>
  <div *ngFor="let section of iagPortalUserManagementPage.sectionsUserManagementAddingNewEmployees">
    <h4>
      <span class="lightBlue">{{ section.title }}</span>
    </h4>
    <div [innerHTML]="section.body | mdToHtml"></div>
    <app-iag-portal-accordian-section class="accordianImageAuto" [accordianSections]="iagPortalUserManagement.sectionFormViewAccordian"></app-iag-portal-accordian-section>
    <div [innerHTML]="section.subBody || '' | mdToHtml"></div>
  </div>
  <app-section [sections]="iagPortalUserManagementPage.sectionsUserManagementPasswordResets" [isIAGPortalDocumentationPage]="true"> </app-section>
  <app-section [sections]="iagPortalUserManagementPage.sectionsUserManagementTwoFactor" [isIAGPortalDocumentationPage]="true"> </app-section>
</div>
